import "../../assets/css/industries/industries.css"

import close from "../../assets/images/close.svg"

import { useState } from "react"
import { Modal } from "react-bootstrap"
import { useAuth } from "../../context/auth-user"
import { BATCH_SIZE, useIndustriesTable } from "./hooks/useIndustriesTable"
import PageSelector from "../pageSelector"
import { IndustriesTable } from "./components/IndustriesTable"

function AddIndustryModal({ show, onHide, onSave }) {
	const [industryName, setIndustryName] = useState("")

	const handleSave = () => {
		if (!industryName.trim()) return
		onSave(industryName)
		setIndustryName("")
	}

	return (
		<Modal
			className="industryModal"
			show={show}
			onHide={onHide}
			size="md"
			centered
		>
			<Modal.Body>
				<img className="closeModal" src={close} onClick={onHide} alt="Prodensa Supplier" />

				<div className="inputContainer">
					<span className="label">Name</span>
					<input 
						type="text" 
						value={industryName}
						onChange={(e) => setIndustryName(e.target.value)} 
					/>
				</div>

				<div className="actions">
					<button className="btnBgBlueTextGradient" onClick={handleSave}>
						Add Industry
					</button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default function NewIndustries() {
	const { user } = useAuth()
	const userLogged = user?.selectedProfile
	const darkLightMode = userLogged?.darkLightMode

	const {
		currentPage,
		totalPages,
		totalCount,
		handlePageChange,
		
		handleShowSortMenu,
		showSortMenu,
		handleSortChange,
		
		searchValue,
		handleSearchChange,
		handleSetSearchFilter,

		sortMenuRef,
		
		showAddModal,
		handleShowAddModal,
		handleHideAddModal,
		handleCreateIndustry,
	} = useIndustriesTable()

	return (
		<section className={`industry ${darkLightMode ? "darkMode" : null}`}>
			<div className="titleAndSearch">
				<h3 className="title">Industry configuration</h3>
				
				<div className="searchAndSort">
					<form onSubmit={handleSetSearchFilter}>
						<div className={`searchContainer ${darkLightMode ? "darkMode" : ""}`}>
							<input 
								id="generalSearch" 
								type="text" 
								placeholder="Search by industry..."
								value={searchValue}
								onChange={handleSearchChange} 
							/>
						</div>
						<button className='applySearchButton' type="submit"></button>
					</form>
					
					<button ref={sortMenuRef} className="d-lg-none sortMobile" onClick={handleShowSortMenu}>
						Sort
					</button>
					
					<div className={`d-lg-none sortDataContainer ${showSortMenu ? "show" : ""}`}>
						<h5 className="title">Sort</h5>
						<span onClick={() => handleSortChange("name", "ASC")}>Industry (ascending)</span>
						<span onClick={() => handleSortChange("name", "DSC")}>Industry (descending)</span>
						<span onClick={() => handleSortChange("suppliersCount", "ASC")}>Quantity (ascending)</span>
						<span onClick={() => handleSortChange("suppliersCount", "DSC")}>Quantity (descending)</span>
					</div>
				</div>
			</div>

			<IndustriesTable />

			<div className="addAndPagination">
				<button 
					className={`btnBgBlueTextGradient ${
						(userLogged?.rol === "Admin client" || userLogged?.rol === "Admin Compliance manager") && "hideElement"
					}`} 
					onClick={handleShowAddModal}
				>
					Add industry
				</button>
				
				<PageSelector 
					className="industriesPagination"
					currentPage={currentPage ?? 1}
					totalItems={totalCount ?? 0}
					itemsPerPage={BATCH_SIZE}
					onChange={handlePageChange}
				/>
			</div>
			
			<span className="tableCount">{currentPage ?? 1} of {totalPages ?? 1}</span>

			<AddIndustryModal
				show={showAddModal}
				onHide={handleHideAddModal}
				onSave={handleCreateIndustry}
			/>
		</section>
	)
}
